module.exports = __webpack_public_path__ + "static/media/62.9e38eb9.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/62.wav
// module id = h1b3
// module chunks = 0